import { toString } from "mdast-util-to-string";
import type { RootContent } from "mdast";
import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import { unified } from "unified";

const parser = unified().use(remarkParse).use(remarkGfm);

function inlineText(node: Parameters<typeof toString>[0]): string {
  return toString(node, { includeHtml: false }).replace(/\s+/g, " ").trim();
}

function blockToText(node: RootContent): string {
  if (node.type === "table") {
    return node.children
      .map((row) =>
        row.children
          .map((cell) => inlineText(cell))
          .filter(Boolean)
          .join(" "),
      )
      .filter(Boolean)
      .join(" ");
  }
  if (node.type === "list") {
    return node.children
      .map((item) => inlineText(item))
      .filter(Boolean)
      .join(" ");
  }
  return inlineText(node);
}

/** One-line plain text for list cells. Links keep their label; table cells are spaced. */
export function markdownToPlainText(markdown: string | null | undefined): string {
  const source = markdown?.trim() ?? "";
  if (!source) return "";
  const tree = parser.parse(source);
  return tree.children
    .map((node) => blockToText(node))
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
}
